import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QuotationFormalityComponent } from '../quotation-dialog/quotation-formality/quotation-formality.component';
import { QuotationAccessoriesComponent } from '../quotation-dialog/quotation-accessories/quotation-accessories.component';
import { firstValueFrom, Subject } from 'rxjs';
import { ReaderPdfComponent } from '../../shared/inputs/reader-pdf/reader-pdf.component';
import { ModalSendEmailComponent } from '../../shared/modals/modal-send-email/modal-send-email.component';
import { Brand } from '../../shared/models/quotation-model/catalogs/brand.model';
import { Coverage } from '../../shared/models/quotation-model/catalogs/coverage.model';
import { DeadLine } from '../../shared/models/quotation-model/catalogs/dead-line.model';
import { PersonType } from '../../shared/models/quotation-model/catalogs/person-type.model';
import { GetQuotationPDF } from '../../shared/models/quotation-model/main/get-Quotation-Pdf.model';
import { QuotationComparative } from '../../shared/models/quotation-model/main/quotation-comparative.model';
import { QuotationEditFinalValues } from '../../shared/models/quotation-model/main/quotation-edit-final-values.model';
import { GeneralService } from '../../shared/services/general.service';
import { QuotationService } from '../../shared/services/quotation/quotation.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-sticky-toolbar',
  templateUrl: './sticky-toolbar.component.html',
  imports: [TranslateModule, MatButtonModule, MatIcon],
  styleUrls: ['./sticky-toolbar.component.scss'],
  standalone: true,
})
export class StickyToolbarComponent implements OnInit {
  @Input() quotationId!: any;
  @Input() ticketId!: number;
  @Input() comparativeData: any;
  @Input() activeQuotationPDFInput!: boolean;
  @Input() selectedDeadLineInput!: DeadLine;
  @Input() selectedPersonType!: PersonType;

  @Output() updateComparative = new EventEmitter<any>();

  enableSend!: boolean;
  activeQuotationPDF!: boolean;
  hasQuotation!: boolean;

  selectedBrand = {} as Brand;
  selectedCoverages: Coverage[] = [];

  selectedQuotationComparative!: QuotationComparative;
  quotationComparatives: QuotationComparative[] = [];
  selectedDeadline!: DeadLine;
  selectedQuotationFinancialValue: QuotationEditFinalValues = {} as QuotationEditFinalValues;
  selectedDeadLines: DeadLine[] = [];

  getQuotationPDF!: GetQuotationPDF;

  private dialogClosedSubject: Subject<any> = new Subject<any>();
  private dialogClosed$ = this.dialogClosedSubject.asObservable();
  constructor(
    public dialog: MatDialog,
    private quotationService: QuotationService,
    private generalService: GeneralService,
  ) {}

  ngOnInit(): void {
    this.activeQuotationPDF = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.activeQuotationPDF = this.activeQuotationPDFInput;
    this.selectedDeadline = this.selectedDeadLineInput;
    if (changes['comparativeData']) {
      this.selectedDeadLines = this.comparativeData.selectedDeadLines;
      this.selectedDeadline = this.comparativeData.selectedDeadline;
      this.selectedQuotationComparative = this.comparativeData.selectedQuotationComparative;
      this.selectedQuotationFinancialValue = this.comparativeData.selectedQuotationFinancialValue;
      this.selectedCoverages = this.comparativeData.selectedCoverages;
      this.quotationComparatives = this.comparativeData.quotationComparatives;
    }
  }

  openAccessoriesDialog() {
    const dialogRef = this.dialog.open(QuotationAccessoriesComponent, {
      width: '80vw',
      maxWidth: '80vw',
      height: '620px',
      data: { quotationId: this.quotationId },
      panelClass: 'dialog-container-custom',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.updateComparative.emit();
      // actualizando FinancialValues componente de PremisesSectionComponent
      this.quotationService.emitFinancialValues.emit();
      this.closeDialog(this.quotationId);
    });
  }

  openFormalitysDialog() {
    const dialogRef = this.dialog.open(QuotationFormalityComponent, {
      width: '80vw',
      maxWidth: '80vw',
      data: { quotationId: this.quotationId },
      panelClass: 'dialog-container-custom',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateComparative.emit();
        // actualizando FinancialValues componente de PremisesSectionComponent
        this.quotationService.emitFinancialValues.emit();
        this.closeDialog(this.quotationId);
      }
    });
  }

  openQuotationPDFDialog() {
    this.sendQuotationComparative();
    this.getQuotationPDF = {
      quotationId: this.quotationId,
      brandId: this.selectedBrand.id,
      coverageId: this.selectedCoverages[0].id,
    };
    const dialogRef = this.dialog.open(ReaderPdfComponent, {
      width: '80vw', // 95% del ancho de la pantalla
      height: '95vh', // 95% del alto de la pantalla
      maxWidth: '80vw',
      maxHeight: '95vh',
      data: {
        quotationId: this.quotationId,
        ulrPDF: 'plantilla-dealer',
      },
    });
  }

  async sendQuotationComparative() {
    const foundComparative = this.quotationComparatives!.find(
      (x) => x.deadlineId == this.selectedDeadline.id,
    );

    this.selectedQuotationComparative = foundComparative!;
    this.selectedQuotationFinancialValue.quotationId =
      this.selectedQuotationComparative.quotationId;
    this.selectedQuotationFinancialValue.accessoriesHook =
      this.selectedQuotationComparative.accessoriesHook;
    this.selectedQuotationFinancialValue.rateCost = this.selectedQuotationComparative.rateCost;
    this.selectedQuotationFinancialValue.rate = this.selectedQuotationComparative.rate;
    this.selectedQuotationFinancialValue.cat = this.selectedQuotationComparative.cat;
    this.selectedQuotationFinancialValue.openingCommissionAmount =
      this.selectedQuotationComparative.openingCommissionAmount;
    this.selectedQuotationFinancialValue.operationInitialDisbursement =
      this.selectedQuotationComparative.operationInitialDisbursement;
    this.selectedQuotationFinancialValue.interestRate =
      this.selectedQuotationComparative.interestRate;
    this.selectedQuotationFinancialValue.earlyWarrantyRent =
      this.selectedQuotationComparative.earlyWarrantyRent;
    this.selectedQuotationFinancialValue.vat = this.selectedQuotationComparative.vat;
    this.selectedQuotationFinancialValue.residualValue =
      this.selectedQuotationComparative.residualValue;
    this.selectedQuotationFinancialValue.payment = this.selectedQuotationComparative.payment;
    this.selectedQuotationFinancialValue.paymentNoVat =
      this.selectedQuotationComparative.paymentNoVat;
    this.selectedQuotationFinancialValue.paymentInsurance =
      this.selectedQuotationComparative.paymentInsurance;
    this.selectedQuotationFinancialValue.managementCostAmount =
      this.selectedQuotationComparative.managementCostAmount;
    this.selectedQuotationFinancialValue.cashAccessoriesAmount =
      this.selectedQuotationComparative.cashAccessoriesAmount;
    this.selectedQuotationFinancialValue.financialAccessoriesAmount =
      this.selectedQuotationComparative.financialAccessoriesAmount;
    this.selectedQuotationFinancialValue.udiAgencyInsuranceAmount =
      this.selectedQuotationComparative.udiAgencyInsuranceAmount;
    this.selectedQuotationFinancialValue.udiFinancialAmount =
      this.selectedQuotationComparative.udiFinancialAmount;
    this.selectedQuotationFinancialValue.udiDamagesInsuranceAmount =
      this.selectedQuotationComparative.udiDamagesInsuranceAmount;
    this.selectedQuotationFinancialValue.udiLifeInsurance =
      this.selectedQuotationComparative.udiLifeInsurance;
    this.selectedQuotationFinancialValue.annualInsuranceAmount =
      this.selectedQuotationComparative.annualInsuranceAmount;
    this.selectedQuotationFinancialValue.lifeInsuranceAmount =
      this.selectedQuotationComparative.lifeInsuranceAmount;
    this.selectedQuotationFinancialValue.damageInsuranceTotalAmount =
      this.selectedQuotationComparative.damageInsuranceTotalAmount;
    this.selectedQuotationFinancialValue.quotationIdFromWS =
      this.selectedQuotationComparative.quotationIdFromWS;
    this.selectedQuotationFinancialValue.assuranceQuotationId =
      this.selectedQuotationComparative.assuranceQuotationId;
    this.selectedQuotationFinancialValue.unemploymentInsuranceAmount =
      this.selectedQuotationComparative.unemploymentInsuranceAmount;
    this.selectedQuotationFinancialValue.insuranceTypesSumsAmount =
      this.selectedQuotationComparative.insuranceTypesSumsAmount;
    this.selectedQuotationFinancialValue.totalAmount =
      this.selectedQuotationComparative.totalAmount;
    this.selectedQuotationFinancialValue.deadlineDescription =
      this.selectedQuotationComparative.deadlineDescription; // term1
    this.selectedQuotationFinancialValue.coverageId = this.selectedQuotationComparative.coverageId;
    this.selectedQuotationFinancialValue.coverageIds = this.createComaString(
      this.selectedCoverages,
    );
    this.selectedQuotationFinancialValue.srs = this.selectedQuotationComparative.srs;
    this.selectedQuotationFinancialValue.discountCard =
      this.selectedQuotationComparative.discountCard;
    this.selectedQuotationFinancialValue.deadlineIds = this.createComaString(
      this.selectedDeadLines,
    );
    this.selectedQuotationFinancialValue.gpsPago = this.selectedQuotationComparative.gpsPago;
    this.selectedQuotationFinancialValue.gpsTotal = this.selectedQuotationComparative.gpsTotal;
    this.selectedQuotationFinancialValue.gpsTipoPago =
      this.selectedQuotationComparative.gpsTipoPago;

    await firstValueFrom(
      this.quotationService.changeFinalValuesQuotation(this.selectedQuotationFinancialValue),
    );
  }

  createComaString(items: { id: number }[]) {
    var deadLinesString = '';
    items.forEach((item) => {
      deadLinesString += item.id + ',';
    });
    const deadLineEditText = deadLinesString.slice(0, -1);
    return deadLineEditText;
  }

  public sendEmail(): void {
    const dialogRef = this.dialog.open(ModalSendEmailComponent, {
      width: 'auto',
      height: 'auto',
      disableClose: true,
      autoFocus: false,
      data: {
        text: 'Envia la corizacion a tu correo electronico',
        titule: 'Envia cotización',
      },
    });
    dialogRef.afterClosed().subscribe(async (result: null | string) => {
      if (result) {
        const body: {
          dealer: number;
          email: string;
          idQuotation: number;
          isMasivo: false;
          personType: number;
          subject: string;
        } = {
          dealer: 1,
          email: result,
          idQuotation: this.quotationId,
          isMasivo: false,
          personType: this.selectedPersonType.id,
          subject: `Cotizacion-${this.quotationId}`,
        };
        this.quotationService.sendQuoteEmail(body).subscribe((ress) => {
          this.generalService.viewSnacAlert('Email enviado', 'normal', 'Email enviado');
        });
      }
    });
  }

  private closeDialog(data: any): void {
    this.dialogClosedSubject.next(data);
  }
}
